import { useEffect, useState } from 'react';
import { usePOSStore } from '../stores/posStore';

export default function OfflineIndicator(): JSX.Element {
  const [showIndicator, setShowIndicator] = useState<boolean>(false);
  const isOnline = usePOSStore((state) => state.isOnline);

  useEffect((): void | (() => void) => {
    if (!isOnline) {
      setShowIndicator(true);
      return undefined;
    } else {
      const timer = setTimeout(() => setShowIndicator(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline]);

  if (!showIndicator) {
    return <></>;
  }

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 p-3 text-center text-white text-sm font-medium transition-all ${
        isOnline ? 'bg-green-500' : 'bg-red-500'
      }`}
    >
      {isOnline
        ? '✓ Back online - syncing data...'
        : '⚠ You are offline - changes will be saved locally'}
    </div>
  );
}
